import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const useLanguageSync = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    if (pathParts.length > 0) {
      const langFromUrl = pathParts[0];
      const supportedLangs = ['ua', 'en', 'pl', 'de', 'es', 'ru'];
      
      if (supportedLangs.includes(langFromUrl) && i18n.language !== langFromUrl) {
        i18n.changeLanguage(langFromUrl);
      }
    }
  }, [location.pathname, i18n]);

  useEffect(() => {
    const handlePopState = () => {
      setTimeout(() => {
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        if (pathParts.length > 0) {
          const langFromUrl = pathParts[0];
          const supportedLangs = ['ua', 'en', 'pl', 'de', 'es', 'ru'];
          
          if (supportedLangs.includes(langFromUrl) && i18n.language !== langFromUrl) {
            i18n.changeLanguage(langFromUrl);
          }
        }
      }, 50);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [i18n]);
};


